import { useSelector } from 'react-redux';
import { getPrimarySubscriptionInfoForGoal } from '@selectors/subscription';
import { subscriptionTypes } from '@constants/index';

const useUserSubscriptionType = (goalUid) => {
  const subscriptionInfo = useSelector(
    getPrimarySubscriptionInfoForGoal(goalUid)
  );
  // getPrimarySubscriptionInfoForGoal falls back to the latest subscription
  // record for the goal even if it has expired (other consumers of that
  // selector rely on seeing expired records). An expired record means the
  // user no longer holds that tier, so treat it as FREE here.
  const isExpired = (subscriptionInfo?.time_remaining ?? 0) <= 0;
  const type = !isExpired
    ? subscriptionInfo?.subscription?.type ?? subscriptionTypes.FREE
    : subscriptionTypes.FREE;

  return type;
};

export default useUserSubscriptionType;
